import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { generateDateID } from "../services/dayPostService";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import BottomNavBar from "../components/layout/BottomNav";
import Header from "../components/layout/Header";
import { useSubscription } from "../providers/SubscriptionProvider";
import ComingSoon from "../components/ComingSoon";

const DataVisualiser = () => {
  const navigate = useNavigate();
  const { isPlusOrHigher } = useSubscription();
  const [comingSoonFeature, setComingSoonFeature] = useState<string | null>(
    null,
  );
  const today = new Date();
  const todayDateID = generateDateID(today);

  const goToTrainingInsights = () => {
    navigate(`/insights/training?date=${todayDateID}`);
  };

  const goToWellnessInsights = () => {
    navigate(`/insights/wellness?date=${todayDateID}`);
  };

  const goToPeakInsights = () => {
    navigate(`/insights/peak?date=${todayDateID}`);
  };

  const goToSleepInsights = () => {
    navigate(`/insights/sleep?date=${todayDateID}`);
  };

  const goToActivityInsights = () => {
    navigate(`/insights/activities`);
  };

  const goToDownloadData = () => {
    navigate(`/downloaddata`);
  };

  const goToDailyReport = () => {
    navigate(`/dailyreport`);
  };

  return (
    <div className="w-full pt-16 pb-32 min-h-screen">
      <Header />
      {/* Header */}
      <div className="px-8 sm:px-0">
        <div className="mx-auto max-w-3xl py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center  pt-4">
              <div className="flex items-center">
                <h1 className="text-3xl sm:text-3xl md:text-4xl font-heading font-semibold text-base-content">
                  Data Insights
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-3xl mx-auto space-y-3 px-8 sm:px-0">
        <div
          className="bg-base-100 p-6  mt-3 rounded-md md:rounded-xl shadow-lg cursor-pointer hover:shadow-md transition-shadow"
          onClick={goToTrainingInsights}
        >
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl  font-openrunde">Training Load</h1>
            </div>
            <ChevronRightIcon className="h-6 w-6 " />
          </div>
        </div>
        <div
          className="bg-base-100 p-6 rounded-md md:rounded-xl shadow-lg cursor-pointer hover:shadow-md transition-shadow"
          onClick={goToWellnessInsights}
        >
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl ">Wellness</h1>
            </div>
            <ChevronRightIcon className="h-6 w-6 " />
          </div>
        </div>
        <div
          className="bg-base-100 p-6  rounded-md md:rounded-xl shadow-lg cursor-pointer hover:shadow-md transition-shadow"
          onClick={() => {
            if (isPlusOrHigher) {
              goToPeakInsights();
            } else {
              setComingSoonFeature("peakReadiness");
            }
          }}
        >
          {" "}
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl ">Peak Readiness</h1>
            </div>
            <ChevronRightIcon className="h-6 w-6 " />
          </div>
        </div>
        <div
          className="bg-base-100 p-6 rounded-md md:rounded-xl shadow-lg cursor-pointer hover:shadow-md transition-shadow"
          onClick={goToSleepInsights}
        >
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl ">Health & Sleep</h1>
            </div>
            <ChevronRightIcon className="h-6 w-6 " />
          </div>
        </div>
        <div
          className="bg-base-100 p-6 rounded-md md:rounded-xl shadow-lg cursor-pointer hover:shadow-md transition-shadow"
          onClick={() => {
            if (isPlusOrHigher) {
              goToActivityInsights();
            } else {
              setComingSoonFeature("activityInsights");
            }
          }}
        >
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl ">Activities & Exercises</h1>
            </div>
            <ChevronRightIcon className="h-6 w-6 " />
          </div>
        </div>
        {/* <div
          className="bg-base-100 p-6  rounded-md md:rounded-xl shadow-lg cursor-pointer hover:shadow-md transition-shadow"
          onClick={goToDailyReport}
        >
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl">Daily Report</h1>
              <p className="text-sm font-grotesk ">
                Comprehensive daily summary and analytics
              </p>
            </div>
            <ChevronRightIcon className="h-6 w-6" />
          </div>
        </div> */}
        <div className="bg-base-100 p-6 bg-opacity-80  rounded-md md:rounded-xl shadow-sm cursor-pointer hover:shadow-md transition-shadow flex justify-between items-center">
          <div>
            <div className="flex items-center">
              <h1 className="text-xl ">
                Injury Risk
                <span className="ml-1 font-grotesk text-sm">PRISM</span>
              </h1>
              <p className="font-grotesk ml-2 bg-lime text-black px-2 text-xs font-bold rounded-md md:rounded-xl">
                coming soon
              </p>
            </div>
            <p className="font-mono text-xs ">
              Personalised Risk (of Injury) Score Model
            </p>
            <p className="font-mono text-xs text-base-content/30 mt-3 bg-base-200 p-1 bg-opacity-30">
              <strong>6 months of data required.</strong> Coming soon..
            </p>
          </div>
        </div>
        <div className="bg-base-100 bg-opacity-80 p-6 rounded-md md:rounded-xl shadow-sm cursor-pointer hover:shadow-md transition-shadow flex justify-between items-center">
          <div>
            <div className="flex items-center">
              <h1 className="text-xl ">Personal Best Predictor</h1>
              <p className="font-grotesk ml-2 bg-lime text-black px-2 text-xs font-bold rounded-md md:rounded-xl">
                coming soon
              </p>
            </div>
            <p className="font-mono text-xs ">
              How your data relates to your personal bests.{" "}
            </p>
            <p className="font-mono text-xs text-base-content/30 mt-3 bg-base-200 p-1 bg-opacity-30">
              <strong>6 months of data required.</strong> Coming soon..
            </p>
          </div>
        </div>

        <div
          className="bg-base-100 border-base-100 border border-1 bg-opacity-30 backdrop-blur-sm p-6 rounded-md md:rounded-xl shadow-lg cursor-pointer hover:shadow-md transition-shadow"
          onClick={goToDownloadData}
        >
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl text-base-contente">Export Data</h1>
              <p className="text-xs font-grotesk text-base-content/70">
                Export and download your data
              </p>
            </div>
            <ChevronRightIcon className="h-6 w-6 " />
          </div>
        </div>
        <BottomNavBar></BottomNavBar>
      </div>

      {/* Coming Soon Modal for gated features */}
      {comingSoonFeature && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setComingSoonFeature(null)}
        >
          <div className="mx-4 max-w-sm" onClick={(e) => e.stopPropagation()}>
            <ComingSoon featureKey={comingSoonFeature} />
          </div>
        </div>
      )}
    </div>
  );
};

export default DataVisualiser;
